const header = {
  DatePicker: () => import("../header/date_picker"),
  MonthPicker: () => import("../header/picker_month"),
  MonthTab: () => import("../header/month_tab"),
  MonthTabTwo: () => import("../header/month_tabtwo"),
  MonthTabThree: () => import("../header/month_tabthree"),
  MonthTabFour: () => import("../header/month_tabfour"),
  MonthTabFive: () => import("../header/month_tabfive"),
  MonthTabSix: () => import("../header/month_tabsix"),
  MonthTabSeven: () => import("../header/month_tabseven"),
  MonthTabEight: () => import("../header/month_tabeight"),
  MonthTabNine: () => import("../header/month_tabnine"),
  MonthTabTen: () => import("../header/month_tabten"),
  TimeTab: () => import("../header/time_tab"),
  Month: () => import("../header/month_one"),
  MonthTwo: () => import("../header/month_two"),
  Totast: () => import("../header/totast_one"),
  TotastTwo: () => import("../header/totast_two"),
  TotastThree: () => import("../header/totast_three"),
  TotastTwoForReceptionist: () => import("../header/totast_two_receptionist"),
  TotastThreeForReceptionist: () => import("../header/totast_three_receptionist"),
  TotastFour: () => import("../header/totast_four"),
  TotastFourSingle: () => import("../header/totast_four_single"),
  ActivityTotast: () => import("../header/activity_totast"),
  CouponsTotast: () => import("../header/coupons_totast"),
  CardTotast: () => import("../header/card_totast")
};
const content = {
  IndexCommon: () => import("./index_common"),
  ChartContent: () => import("./chart-content"),
  Zoom: () => import("./zoom"),
  // 目标增长，表头2行
  ContrantTable: () => import("../table/contrast_table"),
  // 目标增长，表头一行
  ContrantOneTable: () => import("../table/contrast_onetable"),
  // 概况
  ColorTable: () => import("../table/color_table"),
   // 概况
   ColorTables: () => import("../table/color_table"),
   // 指标概况
   IndexTable: () => import("../table/index_table"),
  // 表头一行，对比
  OneLevel: () => import("../table/one_level"),
  // 表头一行，无对比，维度为时间、时间分布、周期分布等可排序的
  OneTable: () => import("../table/one_table"),
  // 没有维度的表
  noDimensionTable: () => import("../table/noDimension_table"),
  // 趋势图，门店对比。表头2行，维度为日期或门店
  DateTable: () => import("../table/date_table"),
  // 分析。自定义维度，维度不排序
  TableCard: () => import("../table/table_card"),
  // 带下钻饼图的数据
  TableAnalysis: () => import("../table/table_analysis"),
  // 单独的，效率概况的面积概况
  AreaTable: () => import("../table/area_table"),
  // 会员留存的热力图样式的表
  RetainTable: () => import("../table/retain_table"),

  CurrentGather: () => import("../table/current-gather"),
  // TargetTable:(resolve)=>require(["../table/target_table"],resolve),
  // 图指标分类
  SelectChart: () => import("../select/select_chart"),
  // 图指标不分类
  SelectIndex: () => import("../select/select_index"),
  // 表指标不分类
  SelectDrop: () => import("../select/select_drop"),
  // 表指标分类
  SelectClass: () => import("../select/select_class"),
  // 趋势图
  VueHighchart: () => import("../chart/vue-highchart"),
  // 饼图
  VuePie: () => import("../chart/vue-highchart"),
  // 柱状图
  VueColumn: () => import("../chart/vue-column"),
  // 下钻饼图
  VuePie2: () => import("../chart/vue-highchart"),
  // 饼图+趋势的趋势
  AsideTrend: () => import("../chart/aside-trend"),
  // 热力图
  ChartHeatmap: () => import("../chart/chart_heatmap"),
  // 桑基图
  Sangkey: () => import("../chart/sangkey"),
  // 漏斗图
  Funnel: () => import("../chart/funnel"),
  // 漏斗图
  VueFunnel: () => import("../chart/vue-funnel"),
    // 词云图
    WordCloud: () => import('../chart/word_cloud'),
    TreeChart: () => import('../chart/tree_chart'),
};
export { header, content };
